import React from "react";

/**
 * Reusable section title block.
 */
const SectionHeading = ({
  title,
  subtitle,
  eyebrow,
  align = "left",
  light = false,
  className = "",
}) => {
  const alignClass = align === "center" ? "section-heading--center" : "";
  const titleClass = light ? "heading--section heading--section-light" : "heading--section";
  const subClass = light ? "heading--sub heading--sub-light" : "heading--sub";

  return (
    <div className={`section-heading ${alignClass} ${className}`.trim()}>
      {eyebrow ? <p className="heading--eyebrow">{eyebrow}</p> : null}
      {title ? <h2 className={titleClass}>{title}</h2> : null}
      {subtitle ? <p className={subClass}>{subtitle}</p> : null}
    </div>
  );
};

export default SectionHeading;
